import { Injectable } from '@angular/core';
import { LoginUser, Supplier, CostCenter, AddUser } from '../_models';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable()
export class GlobalDataService {
  userInfo: LoginUser = new LoginUser;   
  suppliersResult: Supplier[] = [];
  lstCostCenter: CostCenter[] = [];
  alluserdataResult: AddUser[] = [];
  lstAccount: string[] = [];
  monthNames : string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


  constructor() { }
  
  private flgVOWDLock = new BehaviorSubject<boolean>(false); // {1}

  flgVOWDLock$:  Observable<boolean> = this.flgVOWDLock.asObservable();

  CheckVOWD(FlgVOWD : boolean)
    {
        if (FlgVOWD) { this.flgVOWDLock.next(true);}
        else { this.flgVOWDLock.next(false);}
    }

  getUserData()
  {
    return this.userInfo; 
  }
  setUserData(userData:LoginUser)
  {
    this.userInfo = userData;
  }
  getSupplierData()
  {
    return this.suppliersResult; 
  }
  setSupplierData(supData:Supplier[])
  {
    this.suppliersResult = supData;
  }
  getalluserData()
  {
    return this.alluserdataResult; 
  }
  setallusersdata(AllUserdata:AddUser[])
  {
    this.alluserdataResult =AllUserdata;
  }
  getCostCenterData()
  {
    return this.lstCostCenter; 
  }
  setCostCenterData(costCenterData:CostCenter[])
  {
    this.lstCostCenter = costCenterData;
  }
  getAccountData()
  {
    return this.lstAccount; 
  }
  setAccountData(accountData:string[])
  {
    this.lstAccount = accountData;
  }
  convertToStandardDate(dt:any) {        
            let formattedDt = dt.year + '-' + dt.month + '-' + dt.day
            var date = new Date(dt.year, dt.month - 1, dt.day, 0, 0, 0, 0);
            var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();       // yields date
            var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;    // yields month (add one as '.getMonth()' is zero indexed)
            var year = date.getFullYear();  // yields year
            var hour = date.getHours();     // yields hours 
            var minute = date.getMinutes(); // yields minutes
                var second = date.getSeconds();
                var time = year + "-" + month + "-" + day; //+ " " + hour + ':' + minute + ':' + second;
                return time;
    } 
}
